import { PagePublished, PageUnpublished } from '@/domain/events/PageEvents'
import type { IPublishPagePort } from '@/application/port/in/IPublishPagePort'
import type { IPageRepository } from '@/application/port/out/IPageRepository'
import type { IDomainEventBus } from '@/application/port/out/IDomainEventBus'
import type { Page } from '@/domain/model/Page'

export class PublishPageService implements IPublishPagePort {
  constructor(
    private readonly pageRepository: IPageRepository,
    private readonly eventBus: IDomainEventBus,
  ) {}

  async execute(pageId: string, publish: boolean): Promise<Page> {
    const page = await this.pageRepository.findById(pageId)
    if (!page) throw new Error('Page not found')

    // Use the domain wither method — keeps mutation logic in the entity
    const updated = page.withPublished(publish)
    await this.pageRepository.update(pageId, { published: publish })

    const changed = page.published !== publish
    if (changed) {
      const event = publish
        ? new PagePublished(pageId, page.siteId)
        : new PageUnpublished(pageId, page.siteId)
      await this.eventBus.dispatch([event])
    }

    return updated
  }
}
